import React from 'react'
import {
  FormControl,
  Input,
  InputAdornment,
  IconButton,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

const SearchInput = ({ bindValue, setShowSearch }) => {
  return (
    <form>
      <FormControl>
        <Input
          type="text"
          placeholder="Search"
          name="search"
          disableUnderline={true}
          {...bindValue}
          endAdornment={
            <InputAdornment position="end" onClick={() => setShowSearch(false)}>
              <IconButton>
                <Close />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </form>
  )
}

export default SearchInput
